export class DeckConfig {

    public static FavoriteCardCount = 1;
    public static DuplicateCardCount = 4;
    public static DeckTotalCount = 61;
    public static IncludableProductCount = 1;
    public static CountOfIfNewStack = 4;
}